/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-checkbox[_ngcontent-%COMP%]{padding-left:.5em}mat-radio-button[_ngcontent-%COMP%]{padding-right:.5em;padding-bottom:1em}"];
export { styles as styles };
